/** @format */

import React from 'react'
import styled from 'styled-components'
import { Button, Icon, ButtonProps, _$ } from '@king-design/react'

interface AddButonProps extends ButtonProps {
  className?: string
  style?: string | Record<string, string | number>
  text?: string
  disabled?: boolean
  onClick?: () => void
}

const AddButon: React.FC<AddButonProps> = ({
  className,
  text,
  disabled,
  onClick,
  style = {},
  fluid = true,
  ...props
}) => {
  return (
    <Button
      className={className}
      disabled={disabled}
      style={style}
      onClick={() => {
        onClick && onClick()
      }}
      fluid={fluid}
      {...props}
    >
      <Icon className="k-icon-add-bold" />
      {text || _$('新建')}
    </Button>
  )
}

export default styled(AddButon)`
  border-style: dashed;
`
